import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { configProviderInjectionKey as l } from "../config-provider/src/context.js";
import { shallowRef as f } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { inject as t, computed as n } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const u = "n";
function R(r = {}, m = {
  defaultBordered: !0
}) {
  const e = t(l, null);
  return {
    // NConfigProvider,
    inlineThemeDisabled: e == null ? void 0 : e.inlineThemeDisabled,
    mergedRtlRef: e == null ? void 0 : e.mergedRtlRef,
    mergedComponentPropsRef: e == null ? void 0 : e.mergedComponentPropsRef,
    mergedBreakpointsRef: e == null ? void 0 : e.mergedBreakpointsRef,
    mergedBorderedRef: n(() => {
      var o, d;
      const {
        bordered: i
      } = r;
      return i !== void 0 ? i : (d = (o = e == null ? void 0 : e.mergedBorderedRef.value) !== null && o !== void 0 ? o : m.defaultBordered) !== null && d !== void 0 ? d : !0;
    }),
    mergedClsPrefixRef: e ? e.mergedClsPrefixRef : f(u),
    namespaceRef: n(() => e == null ? void 0 : e.mergedNamespaceRef.value)
  };
}
function p() {
  const r = t(l, null);
  return r ? r.mergedClsPrefixRef : f(u);
}
export {
  R as default,
  u as defaultClsPrefix,
  p as useMergedClsPrefix
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-config.js
// module id = 8
// module chunks = 67